export const AndonCord = Object.freeze({
    LIFT_ANDON_CORD: 'false',
    PULL_ANDON_CORD: 'true',
    ATTRIBUTE_KEY: 'andonCord',
});
